export default "__VITE_ASSET__14bf885d__"